// Source: https://stackoverflow.com/questions/1069666/sorting-object-property-by-values

const objectSort = (arr: any[], asc: boolean = true) => {
  return Object.keys(arr)
    .sort()
    .reduce((a, v) => {
      a[v] = arr[v];
      return a;
    }, {});
};

export default objectSort;
